import styled from 'styled-components';

const QuestionDiv = styled.div`
  padding: 5px 0;
  font-size: 16px;
  font-weight: 400;
`;

export default QuestionDiv;
